// ============================================================================
// print-sheet — Konstanten für das Kunden-Druckblatt (kein React, testbar in Node)
// ----------------------------------------------------------------------------
// Pflichtformulierungen + verbotene Phrasen werden in tests/unit beim Build
// geprüft. Entspricht dem Anforderungsprofil "PV-Richtwert-Kalkulation":
// unverbindliche Kostenschätzung, kein Angebot, keine Preisgarantie.
// ============================================================================

/** Vollständiger Haftungshinweis — wird im Druckblatt prominent angezeigt. */
export const PRINT_DISCLAIMER =
  "Alle Preise sind unverbindliche Richtwerte. " +
  "Diese Zusammenstellung ist eine unverbindliche Kostenschätzung (Richtwert) auf Basis " +
  "verfügbarer EK-Richtwerte (ELMETIC-Preisvergleich 06/2026). " +
  "Kein Angebot, keine Preisgarantie. " +
  "Ein genaues Angebot erfolgt erst nach einer Vor-Ort-Besichtigung. " +
  "Technische und kaufmännische Prüfung erforderlich. " +
  "Gültige Preise und Komponenten werden vor Angebotserstellung geprüft. " +
  "Netzzutritt/Netzbetreiber-Kosten sind NICHT enthalten.";

/** Alle Formulierungen MÜSSEN im Druckblatt enthalten sein (Testgate). */
export const REQUIRED_TERMS = [
  "Richtwert",
  "unverbindliche Kostenschätzung",
  "Kein Angebot",
  "keine Preisgarantie",
  "Technische und kaufmännische Prüfung erforderlich",
  "Gültige Preise und Komponenten werden vor Angebotserstellung geprüft",
  "Ein genaues Angebot erfolgt erst nach einer Vor-Ort-Besichtigung",
] as const;

/**
 * Diese Phrasen dürfen im Druckblatt-Quelltext NICHT vorkommen (Testgate).
 * Hinweis: "unverbindlich" ist erwünscht — "verbindliches Angebot" ist
 * verboten (spezifisch, kein false-positive auf "unverbindlich").
 */
export const FORBIDDEN_PHRASES = [
  "freigegeben",
  "garantiert",
  "verbindliches Angebot",
  "final approved",
  "canApprove: true",
] as const;
